import {
  IMenuRepository,
  SideToolbarItemEntity,
  ResponseValueObject,
} from '@gishub/domain';

export class MenuRepository implements IMenuRepository {
  async getItems(): Promise<ResponseValueObject<SideToolbarItemEntity[]>> {
    return new ResponseValueObject(true, [
      { id: 'layers', label: 'Capas', icon: 'layers', title: 'Capas' },
      { id: 'tour', label: 'Esp. Diálogo', icon: 'handshake', title: 'Espacios de diálogo', titleDetail: 'Detalle' },
      //{ id: 'indicators', label: 'Indicador', icon: 'bar-chart', title: 'Indicador' },
      //{ id: 'cruces',   label: 'Cruces',         icon: 'list', title: 'Cruces' },

      { id: 'import', label: 'Importar', icon: 'upload', title: 'Importar' },

      //{ id: 'navigate', label: 'Navegar',        icon: 'compass', title: 'Navegar' },
      { id: 'chat', label: 'Chat', icon: 'message-square', title: 'Chat' },
      { id: 'measure', label: 'Medición', icon: 'pen-tool', title: 'Medición' },
      { id: 'print', label: 'Imprimir', icon: 'printer', title: 'Imprimir' },
      //{ id: 'settings', label: 'Ajustes',        icon: 'sliders', title: 'Ajustes' },
    ]);
  }
}
